import {Injectable} from '@angular/core';
import {RequestService} from "@services/request.service";
import {environment} from "@environment";

@Injectable({
  providedIn: 'root'
})
export class CartService {
  apiPrefix = '/api/ecom/v1/cart/'

  constructor(
    public requestService: RequestService,
  ) {
  }

  save(cart) {
    return this.requestService.post( this.apiPrefix + 'save', cart, 'nitro');
  }

  remove(id) {
    return this.requestService.get(this.apiPrefix + 'delete/' + id, null,'nitro');
  }


}
